/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import throttle from "lodash.throttle";

import { breakpoints } from "../../styles";

export function useBreakpoints(throttleDelay = 100) {
    const [matchingBreakpoints, setMatchingBreakpoints] = useState<string[]>([
        "xs"
    ]);

    //xs | sm | md | lg | xl
    const breakpointKeys = Object.keys(breakpoints) as Array<
        keyof typeof breakpoints
    >;

    useEffect(() => {
        const resize = throttle(() => {
            setMatchingBreakpoints(
                breakpointKeys.filter(
                    (breakpoint) =>
                        typeof window.matchMedia == "function" &&
                        window.matchMedia(
                            `(min-width: ${breakpoints[breakpoint]}px)`
                        ).matches
                )
            );
        }, throttleDelay);

        resize();

        window.addEventListener("resize", resize);

        return () => {
            window.removeEventListener("resize", resize);
        };
    }, [throttleDelay]);

    return matchingBreakpoints;
}
